/* eslint-disable indent */
/* eslint-disable import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Container } from '@nfs-react/components';

import { useText, useImg } from 'hooks';
import { MOBILE, TABLET, DESKTOP, TO_DESKTOP } from 'helpers/styles/media';
import { ChangeableBackgroundSection } from 'helpers/components';

const Strip = ({ isVersion2 }) => {
  return (
    <ChangeableBackgroundSection
      id="strip-wrapper-bg"
      defaultStyle={{ backgroundColor: 'transparent' }}
    >
      <Wrapper>
        <StripContainer isSticky>
          <Inner isVersion2={isVersion2}>
            <Text>{useText('strip__text', true)}</Text>
            <Logo>{useImg('logo.png', 'strip__logo')}</Logo>
          </Inner>
        </StripContainer>
      </Wrapper>
    </ChangeableBackgroundSection>
  );
};

const Wrapper = styled.section`
  @media ${TABLET} {
    padding: 107px 0 40px;
  }

  @media ${MOBILE} {
    padding: 61px 0;
  }
`;

const StripContainer = styled(Container)`
  display: flex;

  @media ${DESKTOP} {
    align-items: center;
  }

  @media ${TO_DESKTOP} {
    flex-direction: column-reverse;
    align-items: center;
  }

  @media ${MOBILE} {
    max-width: 340px;
  }
`;

const Inner = styled.div`
  width: 471px;
  height: 176px;
  background: linear-gradient(235.12deg, #e1e1e1 -22.21%, #ffffff 58.13%);
  border: 2px solid #ffffff;
  box-shadow: 0px 5px 32px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  margin: 0 auto;
  padding: 30px 32px 35px;

  @media ${DESKTOP} {
    margin: -395px auto 0;
    transform: translate(-12px, 0px);

    ${({ isVersion2 }) =>
      isVersion2 &&
      `
      margin: -410px auto 0;
      transform: translate(-140px, 0px);
  `}
  }

  @media ${TABLET} {
    width: 454.01px;
    height: 169.65px;
    padding: 30px 23px 35px;

    margin-bottom: 18px;
  }

  @media ${MOBILE} {
    width: 320px;
    height: 145px;
    padding: 29px 17px;
  }
`;

const Text = styled.div`
  font-weight: 400;
  font-size: 22px;
  font-style: italic;
  line-height: 32px;
  color: #000000;
  margin-bottom: 24px;
  padding-right: 17px;

  @media ${TABLET} {
    font-size: 21px;
    margin-bottom: 18px;
    transform: translate(-6px, 0px);
  }

  @media ${MOBILE} {
    font-size: 16px;
    line-height: 20px;
    padding-right: 0px;
  }
`;

const Logo = styled.div`
  @media ${TABLET} {
    max-width: 119px;
  }

  @media ${MOBILE} {
    max-width: 124px;
  }
`;

Strip.propTypes = {
  isVersion2: PropTypes.bool,
};

export default Strip;
